module.exports = __webpack_public_path__ + "img/safe-animal-900.09be8f08.jpg";